import * as React from 'react';
export const SearchResultsSettingsContext = React.createContext({});
export const SearchResultsSettingsContextProvider = SearchResultsSettingsContext.Provider;
